/* eslint-disable arrow-body-style */
import React, { useMemo } from 'react';
import { merge } from 'lodash-es';
import { IComponentType } from '@/pages/dashboard/components/PageContainer/type';

interface IConfigData {
  [key: string]: any;
}

interface IProps {
  // 页面配置信息
  config: IComponentType;
  // 上层data
  data: IConfigData;
  // 子组件
  children: React.ReactNode;
}

// 组装接口配置和页面配置的相关信息传递给子组件 ，如：nameEn、nameCn、formatter、width、tooltipEn、tooltipCn等
const MetricConfig = (props: IProps) => {
  const { config, data, children, ...resetProps } = props || {};
  // config 信息到data中
  const metricsData = useMemo(() => {
    return {
      ...(data || {}),
      metricConfig: merge({}, (data?.metricConfig || {}), (config?.metricConfig || {})),
    };
  }, [config, data]);

  return <>
    {
      children && React.Children.map(children, child => React.cloneElement(child, { ...resetProps, data: metricsData, }))
    }
  </>;
};

export default MetricConfig;
